import React from 'react';
import { Link } from 'react-router-dom';
import { ContactDialog } from '../ContactDialog';
import { DemoDialog } from '../DemoDialog';
const MEETOS_LOGO = 'https://cdn.magicpatterns.com/uploads/iq6hvRZthzFQJZFoS3ADtj/meetOS-2.png';
const UPOUI_LOGO = 'https://cdn.magicpatterns.com/uploads/oSQbu5FQ7Hf2JLPDyG8HWr/UPoui_Full_color.svg';
export function SiteFooter() {
  return <footer className="w-full border-t border-white/[0.08] py-16 md:py-20" style={{
    backgroundColor: '#09090B'
  }} data-id="element-704">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-705">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-706">
          {/* Column 1 — Brand */}
          <div data-id="element-707">
            <Link to="/" data-id="element-708">
              <img src={MEETOS_LOGO} alt="MeetOS" className="h-8 w-auto brightness-0 invert" data-id="element-709" />
            </Link>
            <p className="text-sm text-white/40 mt-3" data-id="element-710">
              Le système d'exploitation événementiel.
            </p>
          </div>

          {/* Column 2 — Plateforme */}
          <div data-id="element-711">
            <h4 className="text-sm font-semibold text-white mb-4 font-heading" data-id="element-712">
              Plateforme
            </h4>
            <p className="text-xs text-white/30 uppercase tracking-wider font-mono mb-2" data-id="element-713">
              Disponible aujourd'hui
            </p>
            <nav className="space-y-2" data-id="element-714">
              <Link to="/avant" className="block text-sm text-white/50 hover:text-white transition-colors" data-id="element-715">
                Inscription
              </Link>
              <Link to="/avant" className="block text-sm text-white/50 hover:text-white transition-colors" data-id="element-716">
                Répertoire
              </Link>
              <Link to="/avant" className="block text-sm text-white/50 hover:text-white transition-colors" data-id="element-717">
                Networking
              </Link>
              <Link to="/avant" className="block text-sm text-white/50 hover:text-white transition-colors" data-id="element-718">
                Planning de réunions
              </Link>
              <Link to="/pendant" className="block text-sm text-white/50 hover:text-white transition-colors" data-id="element-719">
                Streaming
              </Link>
              <Link to="/pendant" className="block text-sm text-white/50 hover:text-white transition-colors" data-id="element-720">
                Exposants
              </Link>
              <Link to="/apres" className="block text-sm text-white/50 hover:text-white transition-colors" data-id="element-721">
                Analytics
              </Link>
              <Link to="/pendant" className="block text-sm text-white/50 hover:text-white transition-colors" data-id="element-722">
                PWA
              </Link>
            </nav>
            <p className="text-xs text-white/30 uppercase tracking-wider font-mono mb-2 mt-4" data-id="element-723">
              Prochainement
            </p>
            <nav className="space-y-2" data-id="element-724">
              <Link to="/prochainement" className="block text-sm text-white/50 hover:text-white transition-colors" data-id="element-725">
                Badges & QR
              </Link>
              <Link to="/prochainement" className="block text-sm text-white/50 hover:text-white transition-colors" data-id="element-726">
                Surveys & Q&A
              </Link>
              <Link to="/prochainement" className="block text-sm text-white/50 hover:text-white transition-colors" data-id="element-727">
                Certificats
              </Link>
            </nav>
          </div>

          {/* Column 3 — Entreprise */}
          <div data-id="element-728">
            <h4 className="text-sm font-semibold text-white mb-4 font-heading" data-id="element-729">
              Entreprise
            </h4>
            <nav className="space-y-2" data-id="element-730">
              <div data-id="element-731">
                <ContactDialog data-id="element-732">
                  <button className="text-sm text-white/50 hover:text-white transition-colors text-left" data-id="element-733">
                    Contact
                  </button>
                </ContactDialog>
              </div>
              <div data-id="element-734">
                <DemoDialog data-id="element-735">
                  <button className="text-sm text-white/50 hover:text-white transition-colors text-left" data-id="element-736">
                    Demander une démo
                  </button>
                </DemoDialog>
              </div>
            </nav>
          </div>

          {/* Column 4 — UPOUI */}
          <div data-id="element-737">
            <div className="mt-0" data-id="element-738">
              <img src={UPOUI_LOGO} alt="UPOUI" className="h-6 w-auto" data-id="element-739" />
              <p className="text-xs text-white/30 mt-2" data-id="element-740">Conçu par UPOUI</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/[0.06] text-center space-y-2" data-id="element-741">
          <p className="text-xs text-white/20 font-mono" data-id="element-742">
            © {new Date().getFullYear()} MeetOS. Tous droits réservés.
          </p>
          <p className="text-xs text-white/30 font-mono" data-id="element-743">
            Fièrement conçu au Maroc 🇲🇦
          </p>
        </div>
      </div>
    </footer>;
}